import { Transition } from '@lounge-fe/ui-kit'
import { useFadeInOut } from './FadeInOutProvider'
import type { InitialProps } from './types'

export const Initial: React.FC<React.PropsWithChildren<InitialProps>> = ({
  className,
  children,
}) => {
  const { showInitialComponent, setShowAnimateComponent } = useFadeInOut()

  return (
    <Transition.Fade
      show={showInitialComponent}
      className={className}
      onAnimationEnd={() => {
        if (!showInitialComponent) {
          setShowAnimateComponent(true)
        }
      }}
    >
      {children}
    </Transition.Fade>
  )
}
